import React, { Fragment } from 'react'

const Sandbox = () => <div>Sandbox!</div>

export default Sandbox
